import { useContext } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";
import { CircularProgress, Typography } from "@mui/material";
import { RecordContext } from "../../../components/record/Record";
import { useStore } from "../../../store/store";
import { api } from "../../../api/config";
import { DimensionScoresGrid } from "./DimensionScoresGrid";
import { useScoresData } from "../useScoresData";

export const PsyEvaluationScoresEdit = () => {
	const recordContext = useContext(RecordContext);
	const instrumentResponseId = recordContext?.id as string;
	const navigate = useNavigate();
	const { notifications } = useStore();
	const queryClient = useQueryClient();
	const entityForm = useForm();
	const { scores, formatedFields, isLoading, isError } = useScoresData(instrumentResponseId);

	const onSubmit = async (formData: any) => {
		const scoresPayload = scores.map((score) => {
			const fieldKey = `${score.id}__raw_score`;
			const newValue = formData[fieldKey];
			return {
				id: score.id,
				instrument_dimension: score.instrument_dimension?.id ?? null,
				raw_score: newValue !== undefined ? Number(newValue) : score.raw_score,
			};
		});

		const instrumentId = recordContext?.item?.instrument_id?.id;

		const requestBody = { id_instrument: instrumentId, scores: scoresPayload };

		try {
			await api.patch(`/instruments-forms/crm-responses/${instrumentResponseId}/scores`, requestBody);
			queryClient.invalidateQueries({
				predicate: (query) =>
					typeof query.queryKey[0] === "string" &&
					query.queryKey[0].startsWith(`responses_scores-items-parentId-${instrumentResponseId}`),
			});
			notifications.setNotification({ isOpen: true, message: "Cotações atualizadas com sucesso.", severity: "success" });
			navigate(`/instruments_responses/${instrumentResponseId}/detail`);
		} catch (error: any) {

			notifications.setNotification({ isOpen: true, message: error?.response?.data?.errors?.[0]?.message || error?.response?.data?.errorMessage || "Erro ao atualizar Cotações", severity: "error" });
		}
	};

	if (isLoading) return <CircularProgress sx={{ mt: 5 }} color="secondary" />;
	if (isError) return <Typography sx={{ mt: 5, textAlign: "center" }}>Erro ao carregar cotações</Typography>;
	if (scores.length === 0) return <Typography sx={{ mt: 5, textAlign: "center", color: "text.secondary" }}>Sem cotações disponíveis</Typography>;

	return (
		<form
			id="instruments_responses"
			onSubmit={(e) => {
				e.preventDefault();
				entityForm.handleSubmit(onSubmit)(e);
			}}
		>
			<DimensionScoresGrid
				scores={scores}
				formatedFields={formatedFields}
				entityForm={entityForm}
				type="update"
			/>
		</form>
	);
};
